import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useEscritorios } from '@/hooks/useEscritorios';
import { useAtuacao } from '@/lib/delegacao/atuacao';

import { SO_EU, type ClienteFormData } from './clienteFormUtils';

/** O escritório principal, sem escolha (o servidor decide), para quem é de vários. */
const PADRAO = '__padrao__';

interface CampoClienteDeProps {
  form: ClienteFormData;
  set: (field: keyof ClienteFormData, value: string) => void;
}

/**
 * "Cliente de": o escritório (padrão) ou "Só eu" (PLANO_CLIENTE_DO_ESCRITORIO R2).
 *
 * Fica no passo de Identificação porque o cadastro grava o cliente já no primeiro passo: a
 * escolha tem de ir no POST. No último passo ela chegava tarde, e o "Concluir" tentava
 * tirar o cliente do escritório — 403 para quem não é gestor.
 */
export function CampoClienteDe({ form, set }: CampoClienteDeProps) {
  const { data: escritorios } = useEscritorios();
  // Na conta de outra pessoa o cliente vai para o escritório da delegação: os escritórios
  // listados aqui seriam os do delegado.
  const atuacao = useAtuacao();
  if (atuacao || !escritorios || escritorios.length === 0) return null;
  return (
    <div className="space-y-1.5">
      <Label htmlFor="escritorio_id">Cliente de</Label>
      {/* Sem escolha, o servidor usa o escritório principal: com um só, ele já aparece marcado. */}
      <Select
        value={form.escritorio_id || (escritorios.length === 1 ? escritorios[0].id : PADRAO)}
        onValueChange={(v) => set('escritorio_id', v === PADRAO ? '' : v)}
      >
        <SelectTrigger id="escritorio_id">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {escritorios.length > 1 && !form.escritorio_id && (
            <SelectItem value={PADRAO}>Escritório principal</SelectItem>
          )}
          {escritorios.map((esc) => (
            <SelectItem key={esc.id} value={esc.id}>{esc.nome}</SelectItem>
          ))}
          <SelectItem value={SO_EU}>Só eu (cliente pessoal)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
